import { fn } from '@storybook/test';

import type { Meta, StoryFn } from '@storybook/react';
import type { FormInputProps } from './FormInput';

import { FormInput } from './FormInput';

import { SelectListbox } from 'components/SelectListbox';

const codeString = `
// Has all HTMLInputElement props available except "className" and "style" 
<FormInput  />
`;

// eslint-disable-next-line import/no-default-export
export default {
  title: 'Organisms/FormInput',
  component: FormInput,
  argTypes: {},
  args: {},
  parameters: {
    inspectComponent: FormInput,
    codeString: codeString,
  },
} as Meta<FormInputProps>;

const Template: StoryFn<FormInputProps> = (args) => {
  return <FormInput {...args} />;
};

export const FromInputExample = Template.bind({});

FromInputExample.args = {
  id: 'vak',
  label: 'Vaknaam (NL)',
  labelPosition: 'left',
  required: true,
  onChange: fn(),
};

export const WithCustomInputExample = Template.bind({});

const mockOptions = [
  { label: 'English', value: 'EN' },
  { label: 'Dutch', value: 'NL' },
  { label: 'German', value: 'DE' },
  { label: 'Danish', value: 'DK' },
];

WithCustomInputExample.args = {
  id: 'language',
  label: 'Language',
  labelPosition: 'left',
  required: true,
  customInput: (
    <SelectListbox options={mockOptions} defaultValue="NL" size="medium">
      {mockOptions.map(({ label, value }, index) => (
        <SelectListbox.SelectOption option={{ label, value }} index={index} key={value}>
          {label}
        </SelectListbox.SelectOption>
      ))}
    </SelectListbox>
  ),
};
